/**
 * Dépenses et achats : catégories, statuts, et comparaison micro / réel.
 * Partagé entre l'API (validation, export) et le front (formulaires, bilan).
 */
/** Calquées sur les grandes lignes du plan comptable : un passage au réel reste simple. */
export const EXPENSE_CATEGORIES = [
    'goods',
    'supplies',
    'equipment',
    'software',
    'travel',
    'meals',
    'telecom',
    'rent',
    'fees',
    'training',
    'advertising',
    'bank',
    'insurance',
    'other',
];
export const EXPENSE_CATEGORY_LABELS = {
    goods: 'Marchandises',
    supplies: 'Fournitures',
    equipment: 'Matériel',
    software: 'Logiciels et abonnements',
    travel: 'Déplacements',
    meals: 'Repas',
    telecom: 'Téléphone et internet',
    rent: 'Loyer et coworking',
    fees: 'Honoraires',
    training: 'Formation',
    advertising: 'Publicité',
    bank: 'Frais bancaires',
    insurance: 'Assurances',
    other: 'Autre',
};
export const EXPENSE_STATUSES = ['draft', 'validated'];
/** `einvoice` : facture fournisseur reçue par le réseau, données exactes. */
export const EXPENSE_SOURCES = ['manual', 'photo', 'einvoice'];
/** Devises proposées à la saisie (les plus courantes pour un indépendant français). */
export const EXPENSE_CURRENCIES = ['EUR', 'USD', 'GBP', 'CHF', 'CAD', 'JPY', 'AUD', 'SEK', 'DKK', 'NOK', 'PLN', 'CNY'];
/* --------------------------------------------- comparaison micro / régime réel */
/**
 * Nature de l'activité : elle fixe l'abattement forfaitaire du régime micro
 * (art. 50-0 et 102 ter du CGI), avec un minimum de 305 €.
 */
export const ACTIVITY_TYPES = ['bic_sale', 'bic_service', 'bnc'];
export const ACTIVITY_LABELS = {
    bic_sale: 'Vente de marchandises, hébergement (BIC)',
    bic_service: 'Prestations de services commerciales ou artisanales (BIC)',
    bnc: 'Profession libérale (BNC)',
};
export const ACTIVITY_ALLOWANCE_RATES = {
    bic_sale: 0.71,
    bic_service: 0.5,
    bnc: 0.34,
};
export const MIN_ALLOWANCE_EUR = 305;
const cents = (value) => Math.round(value * 100);
/**
 * Le réel devient intéressant, pour l'impôt, quand les charges dépassent
 * l'abattement forfaitaire. Indicateur seulement : les cotisations sociales,
 * les amortissements et la TVA changent aussi au réel.
 */
export function compareRegimes(turnover, expenses, activity) {
    const rate = ACTIVITY_ALLOWANCE_RATES[activity];
    const turnoverCents = cents(turnover);
    const expensesCents = cents(expenses);
    // Minimum légal de 305 €, sans pouvoir dépasser le chiffre d'affaires.
    const allowanceCents = Math.min(turnoverCents, Math.max(Math.round(turnoverCents * rate), MIN_ALLOWANCE_EUR * 100));
    const microCents = turnoverCents - allowanceCents;
    const realCents = Math.max(0, turnoverCents - expensesCents);
    return {
        turnover: turnoverCents / 100,
        allowance: allowanceCents / 100,
        allowanceRate: rate,
        expenses: expensesCents / 100,
        expenseRatio: turnoverCents > 0 ? expensesCents / turnoverCents : null,
        microProfit: microCents / 100,
        realProfit: realCents / 100,
        realIsLower: turnoverCents > 0 && realCents < microCents,
    };
}
//# sourceMappingURL=expenses.js.map